import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Result, Tooltip } from 'antd';
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import useHasPermission from 'hooks/useHasPermission';
import moment from 'moment';
import { getAllDiscountVoucherData } from 'pages/Componets/API_Modal/DiscountAPI/DiscountVoucherAPIModal';
import React, { useState } from 'react'
import { Card } from 'react-bootstrap';
import ViewModalWithTable from '../AllDiscountVoucherCodeCustomComponent';
import AddDiscountVoucher from './AddDiscountVoucher';
import { formatNumber } from 'devextreme/localization';

const DiscountVoucherDataList = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    const HasPermission = useHasPermission();
    const [selectedId, setSelectedId] = useState<any>(null);

    const [showViewPortModalOpen, setShowViewPortModalOpen] = useState(false);


    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: "id",
            load: async (loadOptions) => {
                try {
                    const { searchValue } = loadOptions;

                    const search = JSON.parse(JSON.stringify(loadOptions));
                    let parameterList = new URLSearchParams();
                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }

                    if (searchValue) {
                        parameterList.append("search", searchValue);
                    }

                    const response = await getAllDiscountVoucherData(parameterList);
                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            },
        });
    };
    const reloadDataSource = () => {
        setRefreshKey((prev) => prev + 1);
    };

    const handleOpenViewPort = (data: any) => {
        setShowViewPortModalOpen(true);
        setSelectedId(data);
    };

    const formatDateToIST = (utcDateString: string): string => {
        if (!utcDateString) return "";
        const date = new Date(utcDateString + "Z");
        return new Intl.DateTimeFormat("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
        })
            .format(date)
            .replace(",", "");
    };

    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className="m-0">Discount Voucher</h5>
                            {HasPermission("DiscountVoucher.Write") && <AddDiscountVoucher reloadDataSource={reloadDataSource} />}
                        </Card.Header>
                        <Card.Body>
                            {HasPermission("DiscountVoucher.Read") ? (
                                <DataGrid
                                    dataSource={dataSource()}
                                    // remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    key={refreshKey}
                                    showBorders={true}
                                    columnAutoWidth={true}
                                >
                                    <Scrolling
                                        mode="standard"
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />
                                    <Paging defaultPageSize={10} />
                                    <Pager
                                        visible={true}
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showPageSizeSelector={true}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <SearchPanel
                                        visible={true}
                                        width={240}
                                        placeholder="Search..."
                                    />
                                    <Summary>
                                        <TotalItem
                                        // column="voucherType"
                                        // summaryType="count"
                                        // displayFormat="Total Vouchers: {0}"
                                        />
                                    </Summary>
                                    {(HasPermission("DiscountVoucher.Write") ||
                                        HasPermission("DiscountVoucher.Delete")) && (
                                            <Column
                                                caption="Action"
                                                width={150}
                                                cssClass="text-center"
                                                cellRender={({ data }) => (
                                                    <div className="d-flex justify-content-center align-items-center gap-2">
                                                        {HasPermission("DiscountVoucher.Read") && (
                                                            <Tooltip>
                                                                <button className='btn btn-sm action-btn' title='View Voucher Details' onClick={() => handleOpenViewPort(data)}>
                                                                    <FontAwesomeIcon icon={faEye} className="ml-2" />
                                                                </button>
                                                            </Tooltip>
                                                        )}
                                                    </div>
                                                )}
                                            />
                                        )}

                                    <Column
                                        dataField="id"
                                        dataType="number"
                                        sortOrder="desc"
                                        visible={false}
                                        allowFiltering={false}
                                    />
                                    <Column
                                        dataField="voucherType"
                                        caption="Voucher Type"
                                        dataType="string"
                                    />
                                    <Column
                                        dataField="discountValue"
                                        caption="Discount Value"
                                        dataType="number"
                                        cssClass="text-center"
                                        cellRender={({ data }) => {
                                            if (data.voucherValue == null) return "";

                                            const formattedValue = formatNumber(data.voucherValue, "#,##0.00");

                                            return data.voucherValueIsPercentage
                                                ? `${formattedValue} %`
                                                : formattedValue;
                                        }}
                                    />
                                    <Column
                                        dataField="minInvoiceAmt"
                                        cssClass='text-center'
                                        caption="Minimum Purchase Amount"
                                        dataType="number"
                                        cellRender={({ data }) => data.minInvoiceAmt?.toFixed(2)}
                                    />

                                    <Column
                                        dataField="fromDate"
                                        caption="From Date"
                                        dataType="date"
                                        format="dd/MM/yyyy"
                                    />

                                    <Column
                                        dataField="toDate"
                                        caption="To Date"
                                        dataType="date"
                                        format="dd/MM/yyyy"
                                    />

                                    {/* <Column
                                    dataField='cuponCount'
                                    dataType='string'
                                    caption='No Of Coupon'
                                    /> */}
                                    <Column
                                        cssClass='text-center'
                                        dataField="withGst "
                                        caption="Is On GST"
                                        dataType="boolean"
                                        cellRender={({ data }) => (
                                            <span>{data.withGst ? "Yes" : "No"}</span>
                                        )}
                                    />
                                    <Column
                                        cssClass='text-center'
                                        dataField="isLifetime "
                                        caption="Is Life Time"
                                        dataType="boolean"
                                        cellRender={({ data }) => (
                                            <span>{data.isLifetime ? "Yes" : "No"}</span>
                                        )}
                                    />
                                    <Column
                                        cssClass='text-center'
                                        dataField="isAllStore "
                                        caption="Is All Store"
                                        dataType="boolean"
                                        cellRender={({ data }) => (
                                            <span>{data.isAllStore ? "Yes" : "No"}</span>
                                        )}
                                    />

                                </DataGrid>
                            ) : (
                                null
                            )}
                        </Card.Body>
                    </Card>
                </div>
            </div>

            <ViewModalWithTable
                selectedId={selectedId}
                show={showViewPortModalOpen}
                onClose={() => setShowViewPortModalOpen(false)}
            />
        </>
    )
}

export default DiscountVoucherDataList
